import React, { useState, useEffect, useMemo } from "react";
import { API } from "../../API";
import AdminWrapper from "./AdminWrapper"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar";
import ReactTable from "react-table-6";
import moment from "moment";
import { getTeacherFullName, getTeacherState, teacherLevel } from "../../Helper";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormField from "../../Components/FormField/FormField";
import Modal from "../../Components/Modal/Modal";
import { Link } from "react-router-dom";
import PopUp from "../../Components/PopUpForm/ShareProfile-PopUp";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { notify } from "react-notify-toast";
import SearchBar from "../../Components/SearchBar/SearchBar";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import Pagination from '@mui/material/Pagination';
import debounce from 'lodash/debounce';
import { Button } from "@mui/material";
import { CalendarMonthRounded } from "@mui/icons-material";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";

const BuildFilterTeacher = (props) => {
  const { initialFilter, submitFilter, setGlobalFilter, exportFilter } = props
	const [filterOption, setFilterOption] = useState(initialFilter)
  const onChangeValue = debounce((key, value) => {
		const newValue = {
			...filterOption,
			[key]: value
		}
		setFilterOption(newValue)
    setGlobalFilter(newValue)
	}, 0);

  return (
		<div id="accordion">
			<div class="card w-100">
				<div class="card-header border-none" id="headingOne">
					<h5 class="mb-0 d-flex justify-content-between">
						<button class="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
							Explore Filter Teacher
						</button>

						<div className="d-flex justify-content-end">
              <button class="btn btn-info" onClick={() => submitFilter(filterOption)} disabled={props.disabled}>
                Apply
              </button>
              <button class="btn btn-info" onClick={() => exportFilter(filterOption)} disabled={props.onExport}>
                Export Filter
              </button>
            </div>
					</h5>
				</div>

				<div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
					<div class="card-body">
						<div className="d-flex flex-column">
							<div className="d-flex flex-row">
								<div className="mx-2 flex-fill">
									<p>First Name</p>
									<input
										onChange={event => onChangeValue("firstName", event.target.value)}
										value={filterOption?.firstName ? filterOption?.firstName : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
                <div className="mx-2 flex-fill">
									<p>Last Name</p>
									<input
										onChange={event => onChangeValue("lastName", event.target.value)}
										value={filterOption?.lastName ? filterOption?.lastName : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
                <div className="mx-2 flex-fill">
									<p>Preferred Name</p>
									<input
										onChange={event => onChangeValue("preferredName", event.target.value)}
										value={filterOption?.preferredName ? filterOption?.preferredName : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2 flex-fill">
									<p>Email</p>
									<input
										onChange={event => onChangeValue("email", event.target.value)}
										value={filterOption?.email ? filterOption?.email : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2">
									<p>Searchable</p>
									<select
                    value={filterOption?.isSearchable}
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("isSearchable", event.target.value)}
									>
										<option value="all">---</option>
										<option value="yes">Yes</option>
                    <option value="no">No</option>
									</select>
								</div>
                <div className="mx-2">
									<p>In Xero</p>
									<select
                    value={filterOption?.isInXero}
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("isInXero", event.target.value)}
									>
										<option value="all">---</option>
										<option value="yes">Yes</option>
                    <option value="no">No</option>
									</select>
								</div>
                <div className="mx-2">
									<p>Teacher Type</p>
									<select
                    value={filterOption?.teacherType}
										className="form-control no-shadow px-2 my-2"
										onChange={event => onChangeValue("teacherType", event.target.value)}
									>
                    <option value="ALLTEACHER">ALL</option>
										<option value="VET">VET</option>
										<option value="ELICOS">ELICOS</option>
										<option value="ECEC">ECEC</option>
									</select>
								</div>
                {
                  filterOption?.teacherType === "ECEC" && (
                    <div className="mx-2">
                      <p>Pay Scale</p>
                      <select
                        value={filterOption?.ececTeacherLevel}
                        className="form-control no-shadow px-2 my-2"
                        onChange={event => onChangeValue("ececTeacherLevel", event.target.value)}
                      >
                        <option value={""}>---</option>
                        <option value={teacherLevel.CERT}>Certificate</option>
                        <option value={teacherLevel.DIPLOMA}>Diploma</option>
                        <option value={teacherLevel.BACHELOR}>Bachelor</option>
                        <option value={teacherLevel.GRADUATE_DIPLOMA}>Graduate Diploma</option>
                      </select>
                    </div>
                  )
                }
                {
                  filterOption?.teacherType === "VET" && (
                    <div className="mx-2">
                      <p>Pay Scale</p>
                      <select
                        value={filterOption?.vetTeacherLevel}
                        className="form-control no-shadow px-2 my-2"
                        onChange={event => onChangeValue("vetTeacherLevel", event.target.value)}
                      >
                        <option value={""}>---</option>
                        <option value={teacherLevel.GOLD}>Gold</option>
                        <option value={teacherLevel.SILVER}>Silver</option>
                        <option value={teacherLevel.BRONZE}>Bronze</option>
                      </select>
                    </div>
                  )
                }

								<div className="mx-2 flex-fill">
									<p>State</p>
									<input
										onChange={event => onChangeValue("state", event.target.value)}
										value={filterOption?.state ? filterOption?.state : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)

}

function AllTeachersTable(props) {
  const [allUsers, setAllUsers] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [keyword, setKeyword] = useState(undefined)
  const [user, setUser] = useState()  // Shared user
  const [isPopup, togglePopup] = useState(false)
  const [formType, setFormType] = useState("")
  const [showConfirmChangeStatusPopup, setShowConfirmChangeStatusPopup] = useState(false)
  const [statusChangedTeacher, setStatusChangedTeacher] = useState(undefined)
  const [showConfirmChangeLevelPopup, setShowConfirmChangeLevelPopup] = useState(false)
  const [levelChangedTeacher, setLevelChangedTeacher] = useState(undefined)
  const [exportBookingTeachersID, setExportBookingTeachersID] = useState([])
  const [exportBookingTeachersName, setExportBookingTeachersName] = useState([])
  const [showExportBookingPopup, setShowExportBookingPopup] = useState(false)
  const [exportBookingStartDate, setExportBookingStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportBookingEndDate, setExportBookingEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [showExportToXeroPopup, setShowExportToXeroPopup] = useState(false)
  const [exportToXeroStartDate, setExportToXeroStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportToXeroEndDate, setExportToXeroEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportToXeroStartDateB, setExportToXeroStartDateB] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportToXeroEndDateB, setExportToXeroEndDateB] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false)
  const history = props.history
  const [isCheckAll, setSelectAllTeachers] = useState(false);
  const [allTeachers, setAllTeachers] = useState([]);
  const [isExportingXero, setExportingXero] = useState(false);
  const [exportBookingStartDateB, setExportBookingStartDateB] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportBookingEndDateB, setExportBookingEndDateB] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [onExportTeacher, setOnExportTeacher] = useState(false)
  const [syncTeachersToXeroID, setSyncTeachersToXeroID] = useState([])
  const [syncTeachersToXeroName, setSyncTeachersToXeroName] = useState([])
  const [isSelectTeacher, setIsSelectTeacher] = useState(false);
  const [isRequestingViewCalendar, setIsRequestingViewCalendar] = useState(false)
  const [isRequestViewCalendarPopup, setIsRequestViewCalendarPopup] = useState(false)
  const [selectedTeacher, setSelectedTeacher] = useState(undefined)
  const [selectedLevel, setSelectedLevel] = useState("")
  const [selectedLevelVet, setSelectedLevelVet] = useState("")
  const [levelChangedTeacherVet, setLevelChangedTeacherVet] = useState(undefined)
  const [showConfirmChangeVetLevelPopup, setShowConfirmChangeVetLevelPopup] = useState(false)

  useEffect(() => {
    setLoading(true);
    const previousSearchKeyword = window.sessionStorage.getItem("all-teachers-search-keyword");
    const previousFilter = window.sessionStorage.getItem("allTeacherFilter")
    const filterData = previousFilter ? JSON.parse(previousFilter) : null
    // if (previousSearchKeyword !== undefined && previousSearchKeyword !== "undefined" && previousSearchKeyword !== "") {
    //   getUsers(1, 10, previousSearchKeyword)
    //   setKeyword(previousSearchKeyword)
    //   window.sessionStorage.setItem("all-teachers-search-keyword", undefined);
    // } else {
    //   getUsers(1, 10);
    // }
    if(filterData) {
      getUsers(1, pageSize, null, filterData)
    }
    else {
      getUsers(1, 10);
    }
    API.allTeachersForAllocate()
    .then(function (result) {
      let users = result.data.filter((t) => !t.deleted_at)
          users.map(user => {
            user.stateData = getTeacherState(user)
            user.name = getTeacherFullName(user)
          })
      setAllTeachers(users)
    })
    .catch(function (err) {
      console.log(err)
    })
  }, []);

  const getUsers = async (page, limit, keyword, filter = {}) => {
    setLoading(true);
    const filterReq = {
			["filter[first_name]"]: filter.firstName,
			["filter[last_name]"]: filter.lastName,
			["filter[preferred_name]"]: filter.preferredName,
			["filter[email]"]: filter.email,
			["filter[state]"]: filter.state,
			["filter[is_searchable]"]: filter.isSearchable,
      ["filter[is_in_xero]"]: filter.isInXero,
      ["filter[teacher_type]"]: filter.teacherType,
      ["filter[ecec_teacher_level]"]: filter.ececTeacherLevel,
      ["filter[vet_teacher_level]"]: filter.vetTeacherLevel,
		}

    API.allUsers(page, limit, keyword, filterReq)
      .then(res => {
        const totalPage = res.data.paginate.total_page
        if (page > totalPage) {
          setCurrentPage(totalPage)
          getUsers(totalPage, limit, keyword, filterReq)
        } else {
          let users = res.data.users.filter((t) => !t.deleted_at)
          users.map(user => {
            user.stateData = getTeacherState(user)
            user.name = getTeacherFullName(user)
          })
          setAllUsers(users);
          setPageCount(totalPage)
          setLoading(false);
        }
      })
      .catch(function (err) {
        console.log(err);
        setLoading(false);
      });
  }

  const exportTeacherList = async (filter = {}) => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = `Export_Teacher_List_${+new Date()}`
    const filterReq = {
			["filter[first_name]"]: filter.firstName,
			["filter[last_name]"]: filter.lastName,
			["filter[preferred_name]"]: filter.preferredName,
			["filter[email]"]: filter.email,
			["filter[state]"]: filter.state,
			["filter[is_searchable]"]: filter.isSearchable,
      ["filter[is_in_xero]"]: filter.isInXero,
      ["filter[teacher_type]"]: filter.teacherType,
      ["filter[ecec_teacher_level]"]: filter.ececTeacherLevel,
      ["filter[vet_teacher_level]"]: filter.vetTeacherLevel,
		}
    API.exportTeacherWithFilter(filterReq)
      .then(res => {
        link.href = URL.createObjectURL(
          new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" })
        );
        link.click();
        setOnExportTeacher(false)
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  const showShareProfile = (user) => {
    setUser(user)
    setFormType("shareProfile")
    togglePopup(true)
  }

  const updateSearchStatus = (user_id, is_searchable) => {
    allUsers.map(user => {
      if (user._id === user_id) {
        user.is_searchable = is_searchable
      }
    })
    // console.log(allUsers)
    API.updateSearchStatus(user_id, is_searchable)
      .then(res => {
        // console.log(res)
        setAllUsers(allUsers)
        notify.show("Search status updated")
      })
      .catch((err) => {
        console.log(err)
        notify.show('Error updating search status')
      })
  }

  const updateTeacherLevel = (user_id, level) => {
    allUsers.map(user => {
      if (user._id === user_id) {
        user.level = level
      }
    })
    // console.log(allUsers)
    API.updateTeacherLevel(user_id, level)
      .then(res => {
        // console.log(res)
        setAllUsers(allUsers)
        notify.show("Teacher level updated")
      })
      .catch((err) => {
        console.log(err)
        notify.show('Error updating search status')
      })
  }

  const updateVetTeacherLevel = (user_id, vet_level) => {
    allUsers.map(user => {
      if (user._id === user_id) {
        user.vet_level = vet_level
      }
    })

    API.updateVetLevelTeacher(user_id, vet_level)
      .then(res => {
        setAllUsers(allUsers)
        notify.show("Teacher level updated")
      })
      .catch((err) => {
        console.log(err)
        notify.show('Error updating search status')
      })
  }

  const toggleSelectAll = () => {
    if (isCheckAll) {
      exportBookingTeachersID.splice(0, exportBookingTeachersID.length);
      exportBookingTeachersName.splice(0, exportBookingTeachersName.length);
      setSelectAllTeachers(false);
    } else {
      allTeachers.forEach((user) => {
        const indexId = exportBookingTeachersID.indexOf(user._id);
        if (indexId === -1) {
          exportBookingTeachersID.push(user._id);
          exportBookingTeachersName.push(user.name);
        }
      })
      
      setSelectAllTeachers(true);
    }
    setExportBookingTeachersID(exportBookingTeachersID)
    setExportBookingTeachersName(exportBookingTeachersName)
  };

  const toggleSelectTeachers = () => {
    if(isSelectTeacher) {
      syncTeachersToXeroID.splice(0, syncTeachersToXeroID.length);
      syncTeachersToXeroName.splice(0, syncTeachersToXeroName.length);
      setIsSelectTeacher(false);
    } else {
      allUsers.forEach((user) => {
        const indexId = syncTeachersToXeroID.indexOf(user._id);
        if (indexId === -1) {
          syncTeachersToXeroID.push(user._id);
          syncTeachersToXeroName.push(user.name);
        }
      })
      setIsSelectTeacher(true);
    }
    setSyncTeachersToXeroID(syncTeachersToXeroID)
    setSyncTeachersToXeroName(syncTeachersToXeroName)
  }

  const updateSyncTeachersToXero = (e) => {
    setLoading(true)
    if (e.target.checked) {
      syncTeachersToXeroID.push(e.target.id);
      syncTeachersToXeroName.push(e.target.name)
    } else {
      const index = syncTeachersToXeroID.indexOf(e.target.id);
      if (index > -1) {
        syncTeachersToXeroID.splice(index, 1);
        syncTeachersToXeroName.splice(index, 1);
      }
    }
    setSyncTeachersToXeroID(syncTeachersToXeroID)
    setSyncTeachersToXeroName(syncTeachersToXeroName)
    setTimeout(() => setLoading(false), 50)
  }

  const updateExportBookingTeachers = (e) => {
    setLoading(true)
    if (e.target.checked) {
      exportBookingTeachersID.push(e.target.id);
      exportBookingTeachersName.push(e.target.name)
    } else {
      const index = exportBookingTeachersID.indexOf(e.target.id);
      if (index > -1) {
        exportBookingTeachersID.splice(index, 1);
        exportBookingTeachersName.splice(index, 1);
      }
    }
    // console.log(exportBookingTeachersID)
    setExportBookingTeachersID(exportBookingTeachersID)
    setExportBookingTeachersName(exportBookingTeachersName)
    setTimeout(() => setLoading(false), 50)
  }

  const handleExportBooking = () => {
    setExporting(true)
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = `Bookings from ${
      moment(exportBookingStartDate).format("DD-MM-YYYY")} to ${
      moment(exportBookingEndDate).format("DD-MM-YYYY")}`
    if (exportBookingTeachersID.length < 1) {
      notify.show("Please select at least one teacher")
    } else {
      if(isExportingXero) {
        API.exportTeacherBookingsXeroByAdmin(
          exportBookingTeachersID,
          exportBookingStartDate,
          exportBookingEndDate,
          exportBookingStartDateB,
          exportBookingEndDateB,
        ).then((res) => {
          link.href = URL.createObjectURL(
            new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"})
          );
          link.click();
          setShowExportBookingPopup(false)
          setExporting(false)
        }).catch((err) => {
          console.log(err);
          setExporting(false)
        })
      } else {
        API.exportTeacherBookingsByAdmin(
          exportBookingTeachersID,
          exportBookingStartDate,
          exportBookingEndDate,
        ).then((res) => {
          link.href = URL.createObjectURL(
            new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"})
          );
          link.click();
          setShowExportBookingPopup(false)
          setExporting(false)
        }).catch((err) => {
          console.log(err);
          setExporting(false)
        })
      }
    }
  }

  const openExportToXeroModal = () => {
    setShowExportToXeroPopup(true)
    API.connectXeroPayroll().then(res => {
      if(res.data.xeroLink) {
        window.open(res.data.xeroLink)
      }
    })
      .catch(err => {
        notify.show("Cannot connect to Xero")
        console.log(err)
      })
  }

  const openExportBookingsModal = () => {
    setShowExportBookingPopup(true)
    API.connectXeroPayroll().then(res => {
      if(res.data.xeroLink) {
        window.open(res.data.xeroLink)
      }
    })
      .catch(err => {
        notify.show("Cannot connect to Xero")
        console.log(err)
      })
  }

  const addTeacherToXero = () => {
    if(syncTeachersToXeroID.length < 1) {
      notify.show("Please select at least one teacher")
    } else {
      API.addTeacherToXero(syncTeachersToXeroID).then(() => {
        notify.show("Add teachers to Xero successfully");
      }).catch(err => {
        if(err.response.status === 403) {
          API.connectXeroPayroll().then(res => {
            if(res.data.xeroLink) {
              window.open(res.data.xeroLink)
            }
          })
            .catch(err => {
              notify.show("Cannot connect to Xero")
              console.log(err)
            })
          } else {
            notify.show(err.response.data.error)
            console.log(err.response)
          }
      });
    }
  }

  const handleExportToXero = () => {
    if (syncTeachersToXeroID.length < 1) {
      notify.show("Please select at least one teacher")
    } else {
      setExporting(true)
      API.importXeroPayRoll(syncTeachersToXeroID, exportToXeroStartDate, exportToXeroEndDate, exportToXeroStartDateB, exportToXeroEndDateB)
        .then(res => {
          setExporting(false)
          console.log(res?.config?.data)
          setShowExportToXeroPopup(false)
        })
        .catch(err => {
          setExporting(false)
          if(err.response.status === 403) {
          API.connectXeroPayroll().then(res => {
            if(res.data.xeroLink) {
              window.open(res.data.xeroLink)
            }
          })
            .catch(err => {
              notify.show("Cannot connect to Xero")
              console.log(err)
            })
          } else {
            notify.show(err.response.data.error)
            console.log(err.response)
          }
        })
    }
  }

  const handleRequestToViewCalendar = () => {
    if (!selectedTeacher._id) return

    setIsRequestingViewCalendar(true)
    API.adminRequestViewCalendarV2({
      teacher_id: selectedTeacher._id
    }).then((res) => {
      notify.show("The email has been sent successfully.")
      setTimeout(function(){
        window.location.reload();
    }, 700);
    }).catch((error) => {
      setIsRequestingViewCalendar(false)
      console.log(error)
    })
  }

  const handleCloseRequestViewPopup = () => {
    setIsRequestViewCalendarPopup(false)
    setSelectedTeacher(undefined)
  }

  const onChangeLevel = (e, original) => {
    const selectedLevel = e.target.value
    if (selectedLevel) {
      setSelectedLevel(e.target.value)
      setShowConfirmChangeLevelPopup(true);
      setLevelChangedTeacher(original);
    }
  }

  const onChangeLevelVet = (e, original) => {
    const selectedLevel = e.target.value;
    if (selectedLevel) {
      setSelectedLevelVet(e.target.value);
      setShowConfirmChangeVetLevelPopup(true);
      setLevelChangedTeacherVet(original);
    }
  }

  const closeConfirmChangeVetLevelPopup = () => {
    setShowConfirmChangeVetLevelPopup(false);
    setLevelChangedTeacherVet(undefined);
    setSelectedLevelVet(undefined);
  }

  const closeConfirmChangeLevelPopup = () => {
    setShowConfirmChangeLevelPopup(false);
    setLevelChangedTeacher(undefined);
    setSelectedLevel(undefined);
  }

  const columns = useMemo(() => [
    {
      Header: "Teacher Name",
      width: 150,
      Cell: (props) => <BasicCell content={props.original.name} />
    },
    {
      Header: "Email",
      width: 260,
      Cell: (props) => <BasicCell content={props.original.email} />
    },
    {
      Header: "Contact Number",
      width: 140,
      Cell: (props) => <BasicCell content={props.original.contact_number} />
    },
    {
      Header: "State",
      width: 80,
      Cell: (props) => <BasicCell content={props.original.stateData} />
    },
    {
      Header: "Teacher Type",
      width: 80,
      Cell: (props) => <BasicCell content={props.original.is_childhood_teacher ? "ECEC" : (props.original.is_elt && props.original.is_vet ? 'ELT & VET' : props.original.is_vet ? 'VET' : 'ELT')} />
    },
    {
      Header: "Profile",
      width: 80,
      Cell: (props) => <Link
        className="mdi mdi-account-circle-outline home-icon-margin-adjust profile-link"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "42px" }}
        to={{ pathname: `/NavigateToShareProfile?id=${props.original._id}` }}
        target="blank"
      />
    },
    {
      Header: "Share",
      width: 80,
      Cell: (props) => <Link
        className="mdi mdi-share home-icon-margin-adjust profile-link"
        id="lnkShareProfile"
        target="_self"
        onClick={() => showShareProfile(props.original)}
      />
    },
    {
      Header: "Timetable",
      width: 80,
      Cell: (props) => <Link
        className="mdi mdi-timetable home-icon-margin-adjust profile-link"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "42px" }}
        title="Nav Teach Calendar"
        onClick={() => {
          window.sessionStorage.setItem("all-teachers-search-keyword", keyword);
          window.sessionStorage.setItem("admin-check-teacher", JSON.stringify(props.original));
          history.push("/TeacherCalendar")
          }}
      />
    },
    {
      Header: "Details",
      width: 80,
      Cell: (props) => <Link
        className="btn btn-primary btn-block btn-c primary-button-no-margin-hover mt-2"
        onClick={() => {
          window.sessionStorage.setItem("all-teachers-search-keyword", keyword);
          window.sessionStorage.setItem("admin-check-teacher", JSON.stringify(props.original));
          history.push("/TeacherpersonalDetails")
        }}
      >
        More
      </Link>
    },
    {
      Header: "Searchable",
      width: 80,
      Cell: (props) => <CheckableButton
        className="mx-auto"
        checkbox
        noBorder
        checked={props.original.is_searchable}
        onChange={() => {
          setShowConfirmChangeStatusPopup(true);
          setStatusChangedTeacher(props.original);
        }}
      />
    },
    {
      Header: "Pay Scale",
      width: 80,
      Cell: (props) =>
        <>
          {
            (props.original?.is_childhood_teacher || props.original?.is_elt) && <FormDropdown
              id="pay-scale"
              onChange={(e) => onChangeLevel(e, props.original)}
              value={ (levelChangedTeacher?._id === props.original._id ? selectedLevel : '') || props.original.level }
            >
              {
                props.original?.is_childhood_teacher
                ? (
                  <>
                    <option value=''>---</option>
                    <option value={teacherLevel.CERT}>Certificate</option>
                    <option value={teacherLevel.DIPLOMA}>Diploma</option>
                    <option value={teacherLevel.BACHELOR}>Bachelor</option>
                    <option value={teacherLevel.GRADUATE_DIPLOMA}>Graduate Diploma</option>
                  </>
                )
                : (
                  props.original?.is_elt && (
                    <>
                      <option value={teacherLevel.JUNIOR}>Junior</option>
                      <option value={teacherLevel.SENIOR}>Senior</option>
                      <option value={teacherLevel.EXPERT}>Expert</option>
                      <option value={teacherLevel.MASTER}>Master</option>
                    </>
                  )
                )
              }
            </FormDropdown>
          }
        </>
    },
    {
      Header: "Pay Scale VET",
      width: 80,
      Cell: (props) =>
      <>
        {
          props.original?.is_vet &&( <FormDropdown
            id="pay-scale"
            onChange={(e) => onChangeLevelVet(e, props.original)}
            value={ (levelChangedTeacherVet?._id === props.original._id ? selectedLevelVet : '') || props.original.vet_level }
          >
              <>
                      <option value=''></option>
                      <option value={teacherLevel.GOLD}>Gold</option>
                      <option value={teacherLevel.SILVER}>Silver</option>
                      <option value={teacherLevel.BRONZE}>Bronze</option>
                    </>
          </FormDropdown>)
        }
      </>
    },
    {
      Header: "Course Category",
      width: 80,
      Cell: (props) => <>
        {
          props.original.is_vet && 
            <p
              style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "42px" }}
            >
              VET
            </p>
        }
        {
          props.original.is_elt && 
            <p
              style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "42px" }}
            >
              ELICOS
            </p>
        }
        {
          props.original.is_childhood_teacher && 
            <p
              style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "42px" }}
            >
              ECEC
            </p>
        }
      </>
    },
    {
      Header: (
        <div style={{display: "flex", "align-items": 'center'}}>
          <CheckableButton
        checkbox
        noBorder
        checked={isCheckAll}
        onChange={toggleSelectAll}
      />
        Export Bookings
        </div>
      ),
      width: 120,
      Cell: (props) => <CheckableButton
        className="mx-auto"
        checkbox
        noBorder
        id={props.original._id}
        name={props.original.name}
        checked={exportBookingTeachersID.includes(props.original._id)}
        onChange={updateExportBookingTeachers}
      />
    },
    {
      Header: (
        <div style={{display: "flex", "align-items": 'center'}}>
          <CheckableButton
        checkbox
        noBorder
        checked={isSelectTeacher}
        onChange={toggleSelectTeachers}
      />
        Export to Xero
        </div>
      ),
      width: 120,
      Cell: (props) => <CheckableButton
        className="mx-auto"
        checkbox
        noBorder
        id={props.original._id}
        name={props.original.name}
        checked={syncTeachersToXeroID.includes(props.original._id)}
        onChange={updateSyncTeachersToXero}
      />
    },
    {
      Header: "Request View Calendar",
      width: 80,
      Cell: (props) => <Button
        style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "42px", fontSize: "20px", color: "#3bb4d8" }}
        title="Request View Teacher Calendar"
        disabled={isRequestingViewCalendar}
        onClick={() => {
            setIsRequestViewCalendarPopup(true)
            setSelectedTeacher(props.original)
          }
        }
      >
        <CalendarMonthRounded />
      </Button>
    },
    {
      Header: "Registered Date",
      width: 150,
      Cell: (props) => <BasicCell content={moment.utc(props.original.registration_date).tz('Australia/Melbourne').format("DD-MM-YYYY HH:mm:ss")} />
    },
  ]);

  const BasicCell = ({ content }) => (
    <div className="basic-cell-container">
      <div className="basic-cell-child-element">{content}</div>
    </div>
  );

  const filterInSession = window.sessionStorage.getItem("allTeacherFilter")
  const preFilter = filterInSession ? JSON.parse(filterInSession) : null
  let initialFilter = preFilter || {
    firstName: null,
    preferredName: null,
    email: null,
    lastName: null,
    state: null,
    isSearchable: null,
    isInXero: null,
    teacherType: null
  }

  const [globalFilter, setGlobalFilter] = useState(initialFilter)

  const submitFilter = async (filter) => {
    const keys = Object.keys(filter)
    keys.forEach(key => {
      if(filter[key] === '') filter[key] = null
    })
    window.sessionStorage.setItem("allTeacherFilter", JSON.stringify(filter))
    getUsers(1, pageSize, null, filter)
  }

  const exportFilter = async (filter) => {
    setOnExportTeacher(true)
    exportTeacherList(filter)
  }

  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <div className="all-availability-table-container">
        <h1 className="text-3xl font-bold text-center">All Teachers</h1>

        <div className="w-100 my-4">
        <BuildFilterTeacher 
						initialFilter={initialFilter} 
						submitFilter={submitFilter}
            exportFilter={exportFilter} 
						disabled={loading}
            onExport={onExportTeacher}
            setGlobalFilter={setGlobalFilter}
					/>
        </div>

        <div className="d-flex justify-content-between mx-1 mb-4">
          {/* <SearchBar
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            handleSearch={() => {
              getUsers(1, pageSize, keyword);
              setCurrentPage(1);
            }}
          /> */}
          <div className="mt-4">
          <button
              className="btn secondary-button-no-margin-hover btn-c"
              onClick={addTeacherToXero}
            >
              Add To Xero
            </button>
            <button
              className="btn secondary-button-no-margin-hover btn-c"
              onClick={openExportBookingsModal}
            >
              Export Bookings
            </button>

            <button
              className="btn secondary-button-no-margin-hover btn-c"
              onClick={openExportToXeroModal}
            >
              Export To Xero
            </button>
          </div>
        </div>
        <ReactTable
          className="-striped -highlight"
          showPagination={false}
          data={allUsers}
          sortable={false}
          loading={loading}
          pageSize={pageSize}
          columns={columns}
        />
        <div className="d-flex justify-content-center">
          <Pagination
            className="mt-3 mr-5"
            page={currentPage}
            count={pageCount}
            onChange={(e, value) => {
              setIsSelectTeacher(false);
              setSyncTeachersToXeroID([]);
              setSyncTeachersToXeroName([]);
              getUsers(value, pageSize, keyword, globalFilter);
              setCurrentPage(value)
            }}
          />
          <FormDropdown
            value={pageSize}
            onChange={(e) => {
              setIsSelectTeacher(false);
              setSyncTeachersToXeroID([]);
              setSyncTeachersToXeroName([]);
              getUsers(currentPage, e.target.value, keyword, globalFilter);
              setPageSize(e.target.value)
            }}
          >
            <option value={5}>5 rows</option>
            <option value={10}>10 rows</option>
            <option value={20}>20 rows</option>
            <option value={50}>50 rows</option>
            <option value={100}>100 rows</option>
          </FormDropdown>
        </div>

        {isPopup && (
          <PopUp user={user} showPopup={togglePopup} formType={formType} />
        )}

        {showConfirmChangeStatusPopup && (
          <Modal
            show={true}
            header="Update Searchable Status"
            className="export-booking-modal"
            onClose={() => {
              setShowConfirmChangeStatusPopup(false);
              setStatusChangedTeacher(undefined);
            }}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-10 text-center">
                Are you sure you want to update the status of {" "}
                {getTeacherFullName(statusChangedTeacher) + " "}
                to {" "}
                <p className={statusChangedTeacher.is_searchable ? "d-inline" : "d-none"}>not</p>{" "}
                searchable?
              </div>
              <div className="mt-5 col-md-8 d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    updateSearchStatus(statusChangedTeacher._id, !statusChangedTeacher.is_searchable);
                    setShowConfirmChangeStatusPopup(false);
                    setStatusChangedTeacher(undefined);
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal>
        )}

        {showConfirmChangeLevelPopup && (
          <Modal
            show={true}
            header="Update Teacher Level"
            className="export-booking-modal"
            onClose={closeConfirmChangeLevelPopup}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-10 text-center">
                Are you sure you want to update the level of {" "}
                {getTeacherFullName(levelChangedTeacher) + " "}
                to {" "}
                <p className="d-inline">
                  { selectedLevel == 'graduate_diploma' ? 'graduate diploma' : selectedLevel }
                </p>
                ?
              </div>
              <div className="mt-5 col-md-8 d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    updateTeacherLevel(
                      levelChangedTeacher._id,
                      selectedLevel
                    )
                    closeConfirmChangeLevelPopup()
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal>
        )}

        {showConfirmChangeVetLevelPopup && (
          <Modal
            show={true}
            header="Update VET Teacher Level"
            className="export-booking-modal"
            onClose={closeConfirmChangeVetLevelPopup}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-10 text-center">
                Are you sure you want to update the VET level of {" "}
                {getTeacherFullName(levelChangedTeacherVet) + " "}
                to {" "}
                <p className="d-inline">
                  {selectedLevelVet}
                </p>
                ?
              </div>
              <div className="mt-5 col-md-8 d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    updateVetTeacherLevel(
                      levelChangedTeacherVet._id,
                      selectedLevelVet
                    )
                    closeConfirmChangeVetLevelPopup()
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal>
        )}

        {showExportBookingPopup && (
          <Modal
            show={true}
            header="Export Bookings"
            className="export-booking-modal"
            onClose={() => setShowExportBookingPopup(false)}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-10">
                <FormDatePicker
                  label="Start Date"
                  onChange={(date) => setExportBookingStartDate(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportBookingStartDate).format("DD-MM-YYYY")}
                  // maxDate={new Date()}
                  dateFormat="YYYY-MM-DD"
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-10">
                <FormDatePicker
                  label="End Date"
                  onChange={(date) => setExportBookingEndDate(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportBookingEndDate).format("DD-MM-YYYY")}
                  dateFormat="YYYY-MM-DD"
                  minDate={exportBookingStartDate}
                  // maxDate={new Date()}
                  maxWidth
                  required
                />
              </div>
              <div className={isExportingXero ? "col-md-10": "d-none"}>
                <FormDatePicker
                  label="Start Date Group B"
                  onChange={(date) => setExportBookingStartDateB(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportBookingStartDateB).format("DD-MM-YYYY")}
                  // maxDate={new Date()}
                  dateFormat="YYYY-MM-DD"
                  maxWidth
                  required
                />
              </div>
              <div className={isExportingXero ? "col-md-10": "d-none"}>
                <FormDatePicker
                  label="End Date Group B"
                  onChange={(date) => setExportBookingEndDateB(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportBookingEndDateB).format("DD-MM-YYYY")}
                  dateFormat="YYYY-MM-DD"
                  minDate={exportBookingStartDateB}
                  // maxDate={new Date()}
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-10">
                <FormField
                  label="Teachers"
                  type="textarea"
                  rows="3"
                  disabled
                  value={exportBookingTeachersName.join(', ')}
                >
                </FormField>
              </div>
              <div>
              <CheckableButton
                checkbox
                id="departments-elicos"
                name="departments"
                title="Export for Xero"
                className="campus-departments-checkbox"
                onChange={e => setExportingXero(e.target.checked)}
                checked={isExportingXero}
              >
                Export for Xero
              </CheckableButton>
              </div>
              <div className="mt-5 col-md-8 d-flex flex-column justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={handleExportBooking}
                  disabled={exporting}
                >
                  Export
                </button>
                <div
                  className={exporting ? "text-center text-secondary pt-1" : "d-none"}
                >
                  Exporting...
                </div>
              </div>
            </div>
          </Modal>
        )}

        {showExportToXeroPopup && (
          <Modal
            show={true}
            header="Export to Xero"
            className="export-booking-modal"
            onClose={() => setShowExportToXeroPopup(false)}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-10">
                <FormDatePicker
                  label="Start Date Group A"
                  onChange={(date) => setExportToXeroStartDate(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportToXeroStartDate).format("DD-MM-YYYY")}
                  // maxDate={new Date()}
                  dateFormat="YYYY-MM-DD"
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-10">
                <FormDatePicker
                  label="End Date Group A"
                  onChange={(date) => setExportToXeroEndDate(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportToXeroEndDate).format("DD-MM-YYYY")}
                  dateFormat="YYYY-MM-DD"
                  minDate={exportToXeroStartDate}
                  // maxDate={new Date()}
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-10">
                <FormDatePicker
                  label="Start Date Group B"
                  onChange={(date) => setExportToXeroStartDateB(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportToXeroStartDateB).format("DD-MM-YYYY")}
                  // maxDate={new Date()}
                  dateFormat="YYYY-MM-DD"
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-10">
                <FormDatePicker
                  label="End Date Group B"
                  onChange={(date) => setExportToXeroEndDateB(moment(date).format("YYYY-MM-DD"))}
                  value={moment(exportToXeroEndDateB).format("DD-MM-YYYY")}
                  dateFormat="YYYY-MM-DD"
                  minDate={exportToXeroStartDate}
                  // maxDate={new Date()}
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-10">
                <FormField
                  label="Teachers"
                  disabled
                  type="textarea"
                  rows="3"
                  value={syncTeachersToXeroName.join(', ')}
                >
                </FormField>
              </div>
              <div className="mt-5 col-md-8 d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={handleExportToXero}
                  disabled={exporting}
                >
                  Export
                </button>
                <div
                  className={exporting ? "text-center text-secondary pt-1" : "d-none"}
                >
                  Exporting...
                </div>
              </div>
            </div>
          </Modal>
        )}

        {
          isRequestViewCalendarPopup && (
            <Modal
              className="w-50"
              onClose={handleCloseRequestViewPopup}
              show={isRequestViewCalendarPopup}
            >
              <p className="center-text fs-20">
                An email to ask the teacher to update their availability will be sent. Do you wish to continue?
              </p>
              <br />
              <div className="row mt-5">
                <div className="col-md-6 mb-2 mb-md-0">
                  <CancelButton disabled={isRequestingViewCalendar} onClick={handleCloseRequestViewPopup}>
                    Cancel
                  </CancelButton>
                </div>
                <div className="col-md-6">
                  <ConfirmButton disabled={isRequestingViewCalendar} onClick={() => handleRequestToViewCalendar()}>
                    Yes
                  </ConfirmButton>
                </div>
              </div>
            </Modal>
          )
        }
      </div>
    </AdminWrapper>
  );
}

export default AllTeachersTable;